$.fn.mbix = function(options) {

  // default settings
  var defaults = {
    development: false, // development mode as boolean
  };

  var settings = $.extend( {}, defaults, options );

  // set context
  var container = $(this);

  return this.each(function() {

    // go to next tab
    container.find('.btn-mbix-next').on('click', function(event) {
      $('a[href="'+ this.hash +'"][role="tab"]').tab('show').parent('li').removeClass('disabled');
      $('html, body').animate({scrollTop: container.offset().top - 50}, 300);
  		event.preventDefault();
  	});

    // calculate
    calculation(container);

    container.find('.calc').on('input change', function() {
      calculation(container);
    });

  });

  // calculate
  function calculation(c) {

    // collect elements
    var e01 = c.find('[name="mbix_e_01"]'),
        e02 = c.find('[name="mbix_e_02"]'),
        e03 = c.find('[name="mbix_e_03"]:checked'),
        e04 = c.find('[name="mbix_e_04"]'),
        e05 = c.find('[name="mbix_e_05"]'),
        e05m = c.find('[name="mbix_e_05_m"]'),
        e06 = c.find('[name="mbix_e_06"]:checked'),
        e07 = c.find('[name="mbix_e_07"]:checked'),
        e08 = c.find('[name="mbix_e_08"]:checked'),
        e09 = c.find('[name="mbix_e_09"]:checked'),
        e09m = c.find('[name="mbix_e_09_m"]'),
        e10 = c.find('[name="mbix_e_10"]:checked'),
        e11 = c.find('[name="mbix_e_11"]:checked'),
        e12 = c.find('[name="mbix_e_12"]:checked'),
        e13 = c.find('[name="mbix_e_13"]:checked');

    // collect values
    var v01 = parseInt(e01.val()),
        v02 = parseInt(e02.val()),
        v03 = parseInt(e03.val()),
        v04 = parseInt(e04.val()),
        v05 = parseInt(e05.val()),
        v06 = parseFloat(e06.val()),
        v07 = parseFloat(e07.val()),
        v08 = parseFloat(e08.val()),
        v09 = parseInt(e09.val()),
        v10 = parseFloat(e10.val()),
        v11 = parseInt(e11.val()),
        v12 = parseInt(e12.val()),
        v13 = parseInt(e13.val());

    // chose input
    if (isNaN(v05)) {
      e05m.closest('.mbix-control').removeClass('hidden');
      v05 = parseInt(e05m.val());
    } else {
      e05m.closest('.mbix-control').addClass('hidden');
      v05 = parseInt(e05.val());
    }

    if (v09 === 0) {
      e09m.closest('.mbix-question').removeClass('hidden');
      v09 = parseInt(e09m.val());
    } else {
      e09m.closest('.mbix-question').addClass('hidden');
      v09 = parseInt(e09.val());
    }

    // set values
    e01.closest('.mbix-question').attr('data-value', v01);
    e02.closest('.mbix-question').attr('data-value', v02);
    e03.closest('.mbix-question').attr('data-value', v03);
    e04.closest('.mbix-question').attr('data-value', v04);
    e05.closest('.mbix-question').attr('data-value', v05);
    e06.closest('.mbix-question').attr('data-value', v06);
    e07.closest('.mbix-question').attr('data-value', v07);
    e08.closest('.mbix-question').attr('data-value', v08);
    e09.closest('.mbix-question').attr('data-value', v09);
    e10.closest('.mbix-question').attr('data-value', v10);
    e11.closest('.mbix-question').attr('data-value', v11);
    e12.closest('.mbix-question').attr('data-value', v12);
    e13.closest('.mbix-question').attr('data-value', v13);

    // set answers
    e01.closest('.mbix-question').attr('data-answer', v01);
    e02.closest('.mbix-question').attr('data-answer', v02);
    e03.closest('.mbix-question').attr('data-answer', e03.next('label').text());
    e04.closest('.mbix-question').attr('data-answer', v04);
    e05.closest('.mbix-question').attr('data-answer', v05);
    e06.closest('.mbix-question').attr('data-answer', e06.next('label').text());
    e07.closest('.mbix-question').attr('data-answer', e07.next('label').text());
    e08.closest('.mbix-question').attr('data-answer', e08.next('label').text());
    e09.closest('.mbix-question').attr('data-answer', e09.next('label').text());
    e10.closest('.mbix-question').attr('data-answer', e10.next('label').text());
    e11.closest('.mbix-question').attr('data-answer', e11.next('label').text());
    e12.closest('.mbix-question').attr('data-answer', e12.next('label').text());
    e13.closest('.mbix-question').attr('data-answer', e13.next('label').text());

    // validate values
    var errors = true;

    // validate question 1
    if (v01 === 0) {
      errors = true;
      e01.closest('.mbix-question').addClass('mbix-question-error').find('.error-empty').show();
    } else {
      errors = false;
      e01.closest('.mbix-question').removeClass('mbix-question-error').find('.error-empty').hide();
    }

    // validate question 2
    if ((v02 === 0) || (v02 > (v01 / 2)) || (v02 < (v03 + v04 + v05))) {
      errors = true;
      e02.closest('.mbix-question').addClass('mbix-question-error');

      // validate empty value
      if (v02 === 0) {
        e02.closest('.mbix-question').find('.error-empty').show();
      } else {
        e02.closest('.mbix-question').find('.error-empty').hide();
      }

      // validate half value
      if (v02 > (v01 / 2)) {
        e02.closest('.mbix-question').find('.error-half').show();
      } else {
        e02.closest('.mbix-question').find('.error-half').hide();
      }

      // validate total values
      if (v02 < (v03 + v04 + v05)) {
        e02.closest('.mbix-question').find('.error-total').show();
      } else {
        e02.closest('.mbix-question').find('.error-total').hide();
      }

    } else {
      error = false;
      e02.closest('.mbix-question').removeClass('mbix-question-error').find('.mbix-error').hide();
    }

    // override question 10
    if (v11 === 1 || v12 === 1) {
      v10 = 33.33;
    }
    
    // calculate values
    var f01 = v01,
        f02 = v02,
        f03 = (v03 / v01) * 200,
        f04 = (v04 / v01) * 200,
        f05 = (v05 / v01) * 200,
        sub = ((v02 - v03 - v04 - v05) / f01) * 100,
        f06 = v06,
        f07 = v07,
        f08 = v08,
        f09 = v09,
        f10 = v10,
        f11 = v11,
        f12 = v12,
        f13 = v13;

    // calculate components
    var c01 = f03 + f04 + f05 + sub,
        c02 = (0.5 * f06) + (0.5 * f07),
        c03 = f08,
        c04 = f09,
        c05 = f10,
        x05 = f10 + f11 + f12, // calculate anything for verification
        c06 = f13;
        

    var components = [c01, c02, c03, c04, x05, c06];

    // verify components
    $.each(components, function(index, value) {
      if (isNaN(value) || errors === true) {
        c.find('[href="#mbix_' + (index + 2) + '"][role="button"]').addClass('disabled');
        c.find('[href="#mbix_' + (index + 2) + '"][role="tab"]').parent('li').addClass('disabled');
        c.find('[href="#mbix_' + (index + 2) + '"][role="tab"]').parent('li').nextAll().addClass('disabled');
      } else {
        c.find('[href="#mbix_' + (index + 2) + '"][role="button"]').removeClass('disabled');
      }
    });

    // console.log('Komponente 1: ' + c01);
    // console.log('Komponente 2: ' + c02);
    // console.log('Komponente 3: ' + c03);
    // console.log('Komponente 4: ' + c04);
    // console.log('Komponente 5: ' + c05);
    // console.log('Komponente 6: ' + c06);
    //
    // console.log('---------------------');

    c.find('.result-c1').html(Math.round(c01) + '/100');
    c.find('.result-c2').html(Math.round(c02) + '/100');
    c.find('.result-c3').html(Math.round(c03) + '/100');
    c.find('.result-c4').html(Math.round(c04) + '/100');
    c.find('.result-c5').html(Math.round(c05) + '/100');
    c.find('.result-c6').html(Math.round(c06) + '/100');

    // calculate mbix
    var mbix = (0.2 * c01) + (0.2 * c02) + (0.2 * c03) + (0.2 * c04) + (0.1 * c05) + (0.1 * c06);
    c.find('.result-mbix').html(Math.round(mbix));

    // add print details
    var printTable = c.find('.mbix-details .mbix-table');
    var printTableHtml;

    c.find('.mbix-page').each(function(i) {
      var component = $(this).find('.mbix-title').text();

      printTableHtml += '<tr><th>' + component + '</th></tr>';

      $(this).find('.mbix-question').not('.ignored').each(function(i) {
        var question = $(this).find('.mbix-question-label').text();
        var value = $(this).attr('data-value');
        var answer = $(this).attr('data-answer');
        var label = $(this).find('.mbix-question-number').text();

        printTableHtml += '<tr><td>' + label + ': ' + question + '<br>Anwort: ' + answer + '</td></tr>';
      });

    });

    printTable.html(printTableHtml);

    // development true
    if (settings.development) {
      container.find('.nav.nav-tabs li').removeClass('disabled');
    }
  }
};
